import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { getMarkerStatusColor } from '../../../../../../constants/Colors';
import { STOP_STATUS } from '../../../../../../constants/Stops';
import { Stop } from '../../../../../../domain/stops/Stop';
import { Text } from '../../../../../../react-components/Text';
import { StopPill, TagStyle } from '../../StopPill';

type StopsSearchListProps = {
  canCreateStops?: boolean;
  hasFilter?: boolean;
  routeStops: Stop[];
  styles?: React.CSSProperties;
  onSelectStop: (stopId: string) => void;
};

export const StopsSearchList = ({
  canCreateStops,
  hasFilter,
  routeStops,
  styles,
  onSelectStop,
}: StopsSearchListProps) => {
  if (routeStops.length === 0) {
    return (
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        style={{
          height: `55px`,
          ...styles,
        }}
      >
        <Text
          intlId={
            !hasFilter
              ? canCreateStops
                ? `driver.search_stops.no_search_create`
                : `driver.search_stops.no_search`
              : `driver.search_stops.no_results`
          }
          style={{ color: RoutalPalette.grey11 }}
        />
      </Grid>
    );
  }

  return (
    <Grid style={styles}>
      {routeStops.map((stop, i) => {
        // We init the styles

        let tagStyle: TagStyle = `unhighlighted`;

        // We check the styles

        let color = RoutalPalette.routeBaseColor;
        let secondaryColor = undefined;
        if (
          stop.status === STOP_STATUS.completed ||
          stop.status === STOP_STATUS.canceled ||
          stop.status === STOP_STATUS.incomplete
        ) {
          tagStyle = `highlighted`;

          color = getMarkerStatusColor(stop.status);
          secondaryColor = getMarkerStatusColor(stop.status, `light`);
        }
        return (
          <StopPill
            key={stop.id}
            stop={stop}
            stopType={stop.type}
            componentColor={color}
            secondaryColor={secondaryColor}
            botStyle={`void`}
            topStyle={`void`}
            tagStyle={tagStyle as TagStyle}
            onSelect={(stopId: string) => onSelectStop(stopId)}
            done={
              stop.status === STOP_STATUS.completed ||
              stop.status === STOP_STATUS.canceled ||
              stop.status === STOP_STATUS.incomplete
            }
          />
        );
      })}
    </Grid>
  );
};
